'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

angular.module('ioclients.ctrls', [])
    .controller('ClientViewController', ClientViewController)
    .controller('AddClientController', AddClientController)
    .controller('ClientsController', ClientsController)
    .controller('ClientCreativesViewController', ClientCreativesViewController);

ClientViewController.$inject = [
    '$rootScope',
    '$scope',
    '$stateParams',
    '$state',
    '$ioAlert',
    'ClusterService',
    'DisplayService',
    'FormService',
    'IOClientService',
    'DateRangeService',
    'UserService'];

function ClientViewController(
    $rs,
    $scope,
    $stateParams,
    $state,
    $ioAlert,
    ClusterService,
    DisplayService,
    FormService,
    IOClientService,
    DateRangeService,
    UserService
) {
    var client = $stateParams.client;
    var clientId = $stateParams.id;
    $scope.client = null;
    $scope.clusterId = 0;
    $scope.customClientFormFieldGroups = [];
    $scope.customClientFormFields = [];
    $scope.customClientAttrs = [];
    $scope.customDisplayGroups = [];

    $scope.getClientDetails = function() {
        if (clientId) {
            $scope.clientLoader = true;
            UserService.getClient(clientId).then(function(success) {
                $scope.client = UserService.client;
                $scope.clusterId = $scope.client.cluster_id;
                ClusterService.initCluster($rs.userRole, 'disabled', $scope.clusterId);
                $scope.getCustomClientDetails();
            }, function(error) {
                $ioAlert.show('Error!', 'An error occurred getting the client information.', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Missing client #!', 'error');
        }
    };

    $scope.getCustomClientDetails = function() {
        if (clientId) {
            $scope.clientLoader = true;
            IOClientService.getCustomClientAttrs(clientId).then(function(clientAttrs) {
                if (clientAttrs) {
                    const clusterId = $scope.clusterId;
                    $scope.customClientAttrs = clientAttrs;
                    IOClientService.getCustomClientFormFieldGroups(clusterId).then(function(formFieldGroups) {
                        $scope.customClientFormFieldGroups = formFieldGroups;
                        IOClientService.getCustomClientFormFields(clusterId).then(function(formFields) {
                            $scope.customClientFormFields = formFields;
                            buildDisplayData();
                        });
                    });
                }
            }, function(error) {
                $ioAlert.show('Error!', 'An error occurred getting the custom client information.', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Missing client #!', 'error');
        }
    }

    const buildDisplayData = function() {
        $scope.customDisplayGroups = [];
        let customDisplayGroups = [];

        $scope.customClientFormFieldGroups.forEach(group => {
            let section = {};
            section.title = group.group_name;
            section.groupId = group.id;
            section.data = [];
            if (group.hideForCondition && group.hideForCondition.includes($rs.userRole.role_id)) {
                return;
            }
            customDisplayGroups.push(section);
        });

        $scope.customClientFormFields.forEach(field => {
            if (!FormService.hiddenByParent(field, $scope.customClientFormFields, $scope.customClientAttrs)) {
                if (field.input_type === "readonly" && field.default_value) {
                    $scope.customClientAttrs[field.field_name] = field.default_value;
                }
                if ($scope.customClientAttrs.hasOwnProperty(field.field_name) ) {
                    const group = customDisplayGroups.find(group => group.groupId == field.group_id);
                    if (!group) return;
                    let displayPair = DisplayService.applyTransformation(
                        field,
                        $scope.customClientAttrs[field.field_name]
                    );
                    displayPair.formFieldType = field.input_type;
                    displayPair.formFieldName = field.field_name;
                    group.data.push(displayPair);
                }
            } else {
                delete $scope.customClientAttrs[field.field_name];
            }
        });

        customDisplayGroups.forEach(group => {
            if (group.data && group.data.length > 0) {
                $scope.customDisplayGroups.push(group);
            }
        });
    }

    $scope.backToClients = function() {
        $state.go('ioclients');
    };

    $scope.editClient = function() {
        $state.go('editClient', {
            id: clientId,
            client: $scope.client
        });
    };

    var init = function() {
        if (client) {
            $scope.client = client;
            $scope.clusterId = $scope.client.cluster_id;
            ClusterService.initCluster($rs.userRole, 'disabled', $scope.client.cluster_id);
        } else {
            $scope.getClientDetails();
        }
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

AddClientController.$inject = [
    '$scope',
    '$rootScope',
    '$stateParams',
    'UserService',
    'ClusterService',
    'FormService',
    'IOClientService',
    'DateRangeService',
    '$state',
    '$ioAlert'
];

function AddClientController(
    $scope,
    $rs,
    $stateParams,
    UserService,
    ClusterService,
    FormService,
    IOClientService,
    DateRangeService,
    $state,
    $ioAlert
) {
    var clientId = $stateParams.id;
    var client = $stateParams.client;

    $scope.clientObj = {};
    $scope.users = null;
    $scope.isEditing = false;
    $scope.hasForm = true;
    $scope.clusterId = null;

    if (clientId) {
        $scope.saveText = "Update";
        $scope.addUpdate = "Update";
    } else {
        $scope.saveText = "Create";
        $scope.addUpdate = "Add";
    }

    let initializeForm = function() {
        $scope.model = {};
        $scope.schema = {};
        $scope.form = [];
        $scope.entireForm = [];
        $scope.formFieldMap = {};
        $scope.formParentChildInfo = {};
        $scope.customClientFormFieldGroups = null;
        $scope.customClientFormFields = null;
        $scope.customClientAttrs = null;
    }

    let destroyClusterSelector = $rs.$on('ClusterChanged', function() {
        if ($scope.clusterId == ClusterService.clusterIds[0]) {
            return;
        }
        initializeForm();
        $scope.clusterId = ClusterService.clusterIds[0];
        loadCustomClientForm($scope.clusterId);
    });

    $scope.$on('$destroy', function() {
        destroyClusterSelector();
    });

    var getClientDetails = function() {
        UserService.getClient(clientId).then(function(success) {
            $scope.clientObj = UserService.client;
            ClusterService.initCluster($rs.userRole, 'disabled', $scope.clientObj.cluster_id);
            $scope.clusterId = $scope.clientObj.cluster_id
            loadCustomClientForm($scope.clusterId);
        }, function(error) {
            $ioAlert.show('Error!', 'An error occurred getting the client information.', 'error');
        });
    };

    var saveClientDetails = function(clientData) {
        if ($scope.isEditing) {
            clientData.clusterId = $scope.clientObj.cluster_id;

            UserService.updateClient(clientData).then(function(success) {
                if (UserService.errors) {
                    for (var x = 0; x < UserService.errors.length; x++) {
                        $ioAlert.show("", UserService.errors[x], "error");
                    }
                    UserService.errors = null;
                } else {
                    saveCustomClientAttrs(clientId, clientData.clusterId);
                    $ioAlert.show('', 'Client information updated successfully', 'success');
                    $scope.backToClients();
                }
            }, function(error) {
                $ioAlert.show('Error!', 'An error occurred updating the client information.', 'error');
            });
        } else {
            clientData.clusterId = ClusterService.clusterIds[0];

            UserService.addClient(clientData).then(function(success) {
                if (UserService.errors) {
                    for (var x = 0; x < UserService.errors.length; x++) {
                        $ioAlert.show("", UserService.errors[x], "error");
                    }
                    UserService.errors = null;
                } else {
                    clientId = success.id;
                    saveCustomClientAttrs(clientId, clientData.clusterId);
                    $ioAlert.show('', 'New client saved successfully', 'success');
                    $scope.backToClients();
                }
            }, function(error) {
                $ioAlert.show('Error!', 'An error occurred adding the client information.', 'error');
            });
        }
    };

    $scope.backToClients = function() {
        $state.go('ioclients');
    };

    $scope.saveClient = function(clientForm, customClientForm) {
        if (customClientForm && !customClientForm.$valid) {
            $ioAlert.show("Validation Error!", "Please fill in the required custom client form fields", 'error');
            return;
        }
        if (clientForm.$valid) {
            var data = {};

            data.billingId = $scope.clientObj.billing_id;
            data.crmId = $scope.clientObj.crm_id;
            data.companyName = $scope.clientObj.company_name;
            data.address1 = $scope.clientObj.address_1;
            data.address2 = $scope.clientObj.address_2;
            data.city = $scope.clientObj.city;
            data.state = $scope.clientObj.state;
            data.zip = $scope.clientObj.zip;
            data.country = $scope.clientObj.country;
            data.phone = $scope.clientObj.phone;
            data.fax = $scope.clientObj.fax;
            data.website = $scope.clientObj.website;
            data.firstName = $scope.clientObj.first_name;
            data.lastName = $scope.clientObj.last_name;
            data.reportingStatus = $scope.clientObj.reporting_status;
            data.ioStatus = $scope.clientObj.iotool_status;

            if (clientId) {
                data.id = clientId;
            }

            saveClientDetails(data);
        } else {
            $ioAlert.show("Validation Error!", "Please fill in the required client form fields", 'error');
        }
    };

    async function saveCustomClientAttrs(clientId, clusterId) {
        if ($scope.form.length == 0) {
            return;
        }
        let customClient = FormService.harvestData(
            $scope.customClientFormFields,
            $scope.entireForm, $scope.model,
            'client',
            $scope.formParentChildInfo
        );
        customClient.clientId = clientId;
        customClient.cluster_id = clusterId;
        await IOClientService.saveCustomClientAttrs(customClient);
    }

    // custom client form ===========================================================================
    let loadCustomClientForm = function (clusterId) {
        IOClientService.getCustomClientFormFieldGroups(clusterId).then(function(formFieldGroups) {
            if (formFieldGroups) {
                $scope.customClientFormFieldGroups = formFieldGroups;
                IOClientService.getCustomClientFormFields(clusterId).then(function(formFields) {
                    if (formFields) {
                        $scope.customClientFormFields = formFields;
                        if (!isNaN(clientId)) {
                            IOClientService.getCustomClientAttrs(clientId).then(function(clientAttrs) {
                                $scope.customClientAttrs = clientAttrs;
                                buildSchema();
                                buildForm(
                                    $scope.customClientFormFieldGroups,
                                    $scope.customClientFormFields,
                                );
                            });
                        } else {
                            buildSchema();
                            buildForm(
                                $scope.customClientFormFieldGroups,
                                $scope.customClientFormFields,
                            );
                        }
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'An error occurred getting the client custom form fields.', 'error');
                });
            }
        }, function(error) {
            $ioAlert.show('Error!', 'An error occurred getting the client custom form field groups.', 'error');
        });
    }

    let buildSchema = function () {
        FormService.buildDynamicFormSchema(
            $scope.schema,
            $scope.formFieldMap,
            $scope.customClientFormFields,
            $scope.isEditing,
            $scope.customClientAttrs,
            null,
            null,
            !$scope.isEditing
        );
        if ($scope.isEditing) {
            var editArray = [];
            for (var x in $scope.schema.properties) {
                if ($scope.schema.properties.hasOwnProperty(x)) {
                    editArray.push({
                        "prop": x,
                        "type": $scope.schema.properties[x].type
                    });
                }
            }
            $scope.model = FormService.updateForm($scope.customClientAttrs, editArray);
        }
    }

    let buildForm = function (formFieldGroups, formFields) {
        FormService.buildDynamicForm($scope.model, $scope.entireForm, $scope.formParentChildInfo, $scope.schema, $scope.formFieldMap,
            formFieldGroups, formFields, false, clientId, undefined, undefined, $rs.userRole,'task');
        _.each($scope.entireForm, function (section) {
            if (section.type == 'hidden') {
                return;
            }
            $scope.form.push(section);
        });
    }

    var init = function() {
        initializeForm();
        if (client) {
            $scope.clientObj = client;
            clientId = client.id;

            ClusterService.initCluster($rs.userRole, 'disabled', $scope.clientObj.cluster_id);
            DateRangeService.init();
            $scope.isEditing = true;
            $scope.clusterId = $scope.clientObj.cluster_id;
            loadCustomClientForm($scope.clusterId);
        } else if (clientId) {
            getClientDetails();
            DateRangeService.init();
            $scope.isEditing = true;
        } else {
            $scope.clientObj = {};
            UserService.getClientStatuses().then(function(success) {
                $scope.clientObj.reporting_statuses  = UserService.reporting_statuses;
                $scope.clientObj.io_statuses = UserService.io_statuses;
            }, function(error) {
                $ioAlert.show('Error!', 'An error occurred adding the client', 'error');
            });

            ClusterService.initCluster($rs.userRole, 'singleSelect');
            DateRangeService.init();
        }
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

ClientsController.$inject = ['$scope', '$rootScope', '$timeout', '$state', 'UserService', 'ClusterService', 'DateRangeService', '$ioAlert'];

function ClientsController($scope, $rs, $timeout, $state, UserService, ClusterService, DateRangeService, $ioAlert) {
    $scope.clients = [];
    $scope.can_read_write = 'none';

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $timeout(function() {
            $scope.clientsActive = false;
            $scope.$apply();
        });
        $scope.getClients();
    });

    var initDataTableOptions = function() {
        $scope.dtOptions = {};
        $scope.dtOptions.data = $scope.clients;
        $scope.dtOptions.columns = [
            { field: 'id', format: 'custom', label: 'Client #', className: 'link-cell' },
            { field: 'cluster_name', label: 'Cluster' },
            { field: 'company_name', label: 'Company Name' },
            { field: 'city', label: 'City' },
            { field: 'actions', label: 'Actions', is_primary_key: true, format: 'custom' }
        ];
        $scope.dtOptions.entityName = 'clients';
        $scope.dtOptions.itemName = 'client';
        $scope.dtOptions.iActions = 2;
        $scope.dtOptions.customRenders = {};
        $scope.dtOptions.customRenders['id'] = function(data, type, full) {
            return '<a class="order-link" href="#/admin/ioclients/' + data + '">' + data + '</a>';
        };
        $scope.dtOptions.customRenders['actions'] = function(data, type, full) {
            return (full.source === 'Salesforce' ? '<a class="disabled action action-edit"><span class="icon icon-pencil"></span></a>' :
                '<span style="display: inline-flex"><a class="action action-edit has-tooltip" title="Edit" href="#/admin/ioclients/edit/' + full.id + '"><span class="icon icon-pencil"></span></a>') +
                '<a class="action action-view has-tooltip" title="View" href="#/admin/ioclients/' + full.id + '"><span class="icon icon-eye"></span></a>' +
                '<a class="action action-creative has-tooltip" title="Creative" href="#/admin/ioclientCreatives/' + full.id + '"><span class="icon icon-image"></span></a></span>';
        };
        $scope.dtOptions.fnCreatedRow = function(row, raw, id) {
            $.core.main.tooltip($(row));
        };
    };

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.getClients = function() {
        UserService.getClients(ClusterService.clusterIds).then(function(success) {
            $scope.clients = UserService.clients;
            setDataTableOptions();
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var setDataTableOptions = function() {
        initDataTableOptions();
        $scope.clientsActive = true;
    };

    $scope.addClient = function() {
        $state.go('addClient');
    };

    const init = function() {
        UserService.getUserTaRolePermissions(
            $rs.userRole.ta_role_id,
            $rs.userRole.user_type,
            'client',
        ).then(function(permissions) {
            $scope.can_read_write = permissions?.can_read_write;
        });

        if ($rs.userRole.permissions.indexOf('admin') >= 0) {
            ClusterService.initCluster($rs.userRole, 'hidden');
        } else {
            ClusterService.initCluster($rs.userRole, 'singleSelectWithAllClusters');
        }

        DateRangeService.init();
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

ClientCreativesViewController.$inject = ['$scope', '$rootScope', '$stateParams', 'creativesService', 'MediaService', '$ioAlert', '$state', 'ModalService', 'UserService', 'ClusterService', 'AppConfig'];

function ClientCreativesViewController($scope, $rs, $stateParams, creativesService, MediaService, $ioAlert, $state, ModalService, UserService, ClusterService, AppConfig) {
    $scope.selectedImages = [];
    $scope.thirdPartyCreatives = [];
    $scope.media = {};
    $scope.library = false;
    $scope.isSwapped = false;
    $scope.clientId = $stateParams.id;
    $scope.fromPage = 'clients';
    $scope.accepType = "application/pdf, image/*, video/*"
    $scope.creatives = [];
    $scope.tCreatives = [];
    var currentPage;
    $scope.page = 1;
    $scope.pageObj = {
        perPageOptions: [5, 25, 50, 100],
        perPage: 5,
        search: '',
        currentPage: 1,
        totalCount: 0,
        startIndex: 1,
        endIndex: 1,
        maxSize: 10,
        calculate: function() {
            $scope.pageObj.startIndex = Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
            $scope.pageObj.endIndex = Math.min(($scope.pageObj.currentPage) * $scope.pageObj.perPage);
            if ($scope.pageObj.endIndex > $scope.pageObj.totalCount) {
                $scope.pageObj.endIndex = $scope.pageObj.totalCount;
            }
        }
    };
    $scope.$watch('pageObj.currentPage', function() {
        $scope.pageObj.calculate();
    });
    $scope.$watch('pageObj.perPage', function() {
        $scope.pageObj.calculate();
    });

    $scope.view_tab = "tab1";

    $scope.changeTab = function(tab) {
        $scope.view_tab = tab;
    };

    $scope.swapView = function(isTable) {
        $scope.isSwapped = isTable;
        if (isTable) {
            $scope.pageObj.currentPage = 1;
            $scope.getCreatives();
        }
    };

    $scope.backToClients = function() {
        if ($rs.user.user.use_nui) {
            window.location = AppConfig.NUI_PATH + '#/clients';
        } else {
            if ($rs.userRole.permissions.indexOf('admin') >= 0) {
                $state.go('clients');
            } else {
                $state.go('ioclients');
            }
        }
    };

    $scope.getCreatives = function(from) {
        if (from == 'grid') {
            if ($scope.isLoading || currentPage == $scope.page) {
                return;
            }
            if (currentPage == 0) {
                $scope.creatives = [];
            }
            currentPage = $scope.page;

        }
        $scope.isLoading = true;
        var params = {};
        params = {
            "clientId": $scope.clientId,
            "thumbWidth": 200,
            "orderBy": "created_at",
            "orderType": "desc"
        };

        if (from == 'grid') {
            params.perPage = 10;
            params.page = $scope.page;
        } else {
            params.perPage = $scope.pageObj.perPage;
            params.page = $scope.pageObj.currentPage;
        }
        creativesService.getCreativesForClient(params).then(function(success) {
            _.each(success.creatives, function(creative) {
                if (creative.order_ids) {
                    creative.order_ids = JSON.parse(creative.order_ids);
                }
                if (creative.line_item_ids) {
                    creative.line_item_ids = JSON.parse(creative.line_item_ids);
                }
            });
            if (from == 'grid') {
                $scope.creatives = $scope.creatives.concat(success.creatives);
                if (success.creatives.length) {
                    $scope.page = $scope.page + 1;
                }
                if ($scope.creatives.length) {
                    $scope.noMedia = false;
                } else {
                    $scope.noMedia = true;
                }
            } else {
                $scope.tCreatives = success.creatives;
                $scope.pageObj.totalCount = success.total_count;
                $scope.pageObj.currentPage = success.page;
                $scope.pageObj.calculate();
            }
            $scope.isLoading = false;

        }, function(error) {
            $ioAlert.show('Error!', 'Could not get Creatives.', 'error');
        });
    }

    $scope.addCreatives = function() {
        if ($scope.uploadMedia.images) {
            $ioAlert.show('', 'Creatives are being uploaded dont refresh the page. You can check the status in the notifications tab', 'success');
            angular.forEach($scope.uploadMedia.images, function(file) {
                creativesService.getImgSignature({ clientId: $scope.clientId, fileName: file.name }).then(function(success) {
                    var additionalParams = {
                        "from": "client",
                        "clientId": $scope.clientId,
                        "file_name": file.name,
                        "file_size": file.size
                    }
                    $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
                }, function(error) {
                    const details = JSON.stringify(error);
                    $ioAlert.show('Error!', 'Could not get img signature.' + details, 'error');
                    console.log(error);
                });
            });

        } else {
            $ioAlert.show("Error!", "Upload atleast one file", 'error');
        }
    };

    $scope.attachToOrder = function(creative) {
        var data = {};
        data.creative = creative;
        ModalService.returnModalType('creativeToLineItem', data).result.then(function() {

        }, function(cancel) {
            console.log("cancel");
        })

    };

    /*
     *  Delete file
     */
    $scope.deleteFile = function(fileModal, index) {
        fileModal = fileModal.splice(index, 1);
    }

    $rs.$on('clientUploadSuccess', function(event) {
        $scope.uploadMedia = {};
        currentPage = 0;
        $scope.page = 1;
        $scope.getCreatives('grid');
    });

    var init = function() {
        if ($stateParams.id) {
            ClusterService.initCluster($rs.userRole, 'disabled');
        } else {
            $scope.backToClients();
        }
        $scope.getCreatives('grid');
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

}